export enum ReplenishmentLoader {
  ReplenishmentOrderDetailsLoader = "ReplenishmentOrderDetailsLoader",
}
